import axios from "axios";

export default class Courier {
    fetch(urls, doneCallback) {
        const validUrls = (urls || []).filter(url => (url || '').trim());
        if (validUrls.length == 0) return;

        this._callback = doneCallback;

        this._data = validUrls.reduce((pre, cur) => {
            pre[cur] = { url: cur }
            return pre;
        }, {});

        validUrls.forEach(this._fetchOne);
    }

    _fetchOne = (url) => {
        axios.get(url)
            .then(response => {
                this._fetchOneDone({
                    url,
                    response
                });
            })
            .catch(error => {
                this._fetchOneDone({
                    url,
                    error
                });
            })
    }

    _fetchOneDone = (result) => {
        this._data[result.url] = result;
        const allDone = !Object.values(this._data).find(i => (!i.response && !i.error));

        if (allDone) {
            this._executeCallback(this._data);
        }
    }

    _executeCallback(data) {
        setTimeout(() => {
            this._callback(data);
        }, 0);
    }
}